import { PageHeader } from "@/components/PageHeader";
import { FaqAccordion } from "@/components/FaqAccordion";
import { CTASection } from "@/components/CTASection";
import { IMG } from "@/lib/content";
import { useSeo } from "@/lib/useSeo";

export default function Faq() {
  useSeo({
    title: "FAQ | DST New Braunfels — Training Questions Answered",
    description: "Frequently asked questions about DST New Braunfels — ages we train, booking, private training, session length, and what to bring.",
  });
  return (
    <>
      <PageHeader
        eyebrow="FAQ"
        title={<>Questions?<br />Answered.</>}
        subtitle="Everything you need to know before your first session at DST New Braunfels."
        image={IMG.pitcherField}
      />
      <FaqAccordion showHeader={false} />
      <CTASection />
    </>
  );
}
